import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import beanMascot from "@/assets/bean-mascot.svg";
import SEO from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center px-6 relative overflow-hidden">
      <SEO title="Page Not Found" noindex />
      {/* Giant background 404 */}
      <motion.span
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="absolute font-display italic text-[clamp(14rem,40vw,30rem)] leading-none text-foreground/[0.03] select-none pointer-events-none"
      >
        404
      </motion.span>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 flex flex-col items-center text-center"
      >
        <img
          src={beanMascot}
          alt="KEISH Bean"
          className="w-20 md:w-24 mb-6 opacity-60"
        />

        <p className="font-body text-ts-2xs font-medium tracking-[0.25em] uppercase text-muted-foreground/50 mb-3">
          Page Not Found
        </p>

        <h1 className="font-display text-[clamp(2.5rem,6vw,5rem)] italic leading-[0.9] tracking-tight mb-4">
          Lost in the sauce.
        </h1>

        <p className="font-body text-ts-xs text-muted-foreground max-w-xs mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-3 font-body text-ts-2xs font-medium tracking-[0.2em] uppercase text-foreground group"
        >
          <span className="inline-block w-8 h-px bg-foreground group-hover:w-12 transition-all" />
          <span>Back Home</span>
        </Link>
      </motion.div>

      {/* Subtle path display */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="absolute bottom-8 font-body text-ts-2xs text-muted-foreground/30 tracking-wide"
      >
        {location.pathname}
      </motion.p>
    </div>
  );
};

export default NotFound;
